"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getEmptyUserPhotoLayers = void 0;
const getUserPhotoLayers_1 = require("./getUserPhotoLayers");
const getEmptyUserPhotoLayers = (p, startingPosition, excludedTypes) => {
  let orderedUserPhotoLayers = (0, getUserPhotoLayers_1.getUserPhotoLayers)(p, excludedTypes);
  // If there is a starting layer id, shift the array so that the starting layer is first
  if (startingPosition) {
    const startingLayerIdx = orderedUserPhotoLayers.findIndex(orderedUserPhotoLayer => orderedUserPhotoLayer.printableId === startingPosition.startingPrintableId && orderedUserPhotoLayer.layer.id === startingPosition.startingLayerId);
    if (startingLayerIdx > 0) {
      orderedUserPhotoLayers = [...orderedUserPhotoLayers.slice(startingLayerIdx), ...orderedUserPhotoLayers.slice(0, startingLayerIdx)];
    }
  }
  const emptyUserPhotoLayers = orderedUserPhotoLayers.filter(orderedUserPhotoLayer => !orderedUserPhotoLayer.layer.userData).map(orderedUserPhotoLayer => ({
    rotateWorkspace: !!orderedUserPhotoLayer.rotateWorkspace,
    isCompositeDesign: !!orderedUserPhotoLayer.isCompositeDesign,
    printableGroupId: orderedUserPhotoLayer.printableGroupId,
    printableId: orderedUserPhotoLayer.printableId,
    printableEntityKey: orderedUserPhotoLayer.printableEntityKey,
    layerId: orderedUserPhotoLayer.layer.id
  }));
  return emptyUserPhotoLayers;
};
exports.getEmptyUserPhotoLayers = getEmptyUserPhotoLayers;